import { useSelector } from "@xstate/react";
import { actorsInterpreter } from "../actors_machine";

const { login } = actorsInterpreter.getSnapshot().context;

export function useIsLoginSuccess() {
  return useSelector(login, (state) => state.matches("success"));
}
